jQuery(document).ready(function($) {
    'use strict';

    const quizForm = $('#pricing-quiz');
    const resultsDiv = $('#quiz-results');
    const priceDisplay = $('#quiz-price');
    const detailsDisplay = $('#quiz-details');

    // Initialize quiz
    initQuiz();

    function initQuiz() {
        // Add event listeners to all form inputs
        // Use 'change' for select/radio, 'input' for text/number to avoid duplicates
        quizForm.on('change', 'select, input[type="radio"]', function() {
            handleInputChange($(this));
            calculatePrice();
        });
        
        quizForm.on('input', 'input[type="number"], input[type="text"]', function() {
            handleInputChange($(this));
            calculatePrice();
        });

        // Special handling for salons and shareholders to prevent empty/invalid values
        quizForm.on('blur', '#salons, #shareholders', function() {
            const $input = $(this);
            let value = parseInt($input.val());
            if (isNaN(value) || value < 1) {
                $input.val(1);
                calculatePrice();
            }
        });

        // Prevent typing invalid values
        quizForm.on('keydown', '#salons, #shareholders', function(e) {
            // Allow: backspace, delete, tab, escape, enter
            if ($.inArray(e.keyCode, [46, 8, 9, 27, 13]) !== -1 ||
                // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
                (e.keyCode === 65 && e.ctrlKey === true) ||
                (e.keyCode === 67 && e.ctrlKey === true) ||
                (e.keyCode === 86 && e.ctrlKey === true) ||
                (e.keyCode === 88 && e.ctrlKey === true) ||
                // Allow: home, end, left, right, down, up
                (e.keyCode >= 35 && e.keyCode <= 40)) {
                return;
            }
            // Ensure that it is a number and stop the keypress
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                e.preventDefault();
            }
        });

        // Handle conditional questions
        handleConditionalQuestions();
        
        // Calculate initial price with default values
        calculatePrice();
    }

    function handleInputChange($input) {
        const name = $input.attr('name');
        
        // Ensure salons and shareholders never go below 1 or become empty
        if (name === 'salons' || name === 'shareholders') {
            let value = parseInt($input.val());
            if (isNaN(value) || value < 1) {
                $input.val(1);
            }
        }
        
        // Handle conditional question visibility
        if (name === 'own_building') {
            const buildingsQuestion = $('[data-question="4"]');
            if ($input.val() === 'yes' && $input.is(':checked')) {
                buildingsQuestion.slideDown(300);
                buildingsQuestion.find('input').prop('required', true);
            } else if ($input.val() === 'no' && $input.is(':checked')) {
                buildingsQuestion.slideUp(300);
                buildingsQuestion.find('input').prop('required', false).val('');
            }
        }

        if (name === 'bookkeeping') {
            const bookkeepingQuestion = $('[data-question="7"]');
            if ($input.val() === 'yes' && $input.is(':checked')) {
                bookkeepingQuestion.slideDown(300);
                bookkeepingQuestion.find('input').prop('required', true);
            } else if ($input.val() === 'no' && $input.is(':checked')) {
                bookkeepingQuestion.slideUp(300);
                bookkeepingQuestion.find('input').prop('required', false).val('');
            }
        }

        // Update hidden form fields dynamically
        updateHiddenFields();
        
        // Update form progress
        updateFormProgress();
    }

    function handleConditionalQuestions() {
        // Initially hide conditional questions
        $('.quiz__question--conditional').hide();
    }

    function calculatePrice() {
        // Check if all required fields are filled
        if (!isFormComplete()) {
            resultsDiv.hide();
            return;
        }

        const formData = getFormData();
        const calculation = performCalculation(formData);
        
        displayResults(calculation);
    }

    function isFormComplete() {
        let isComplete = true;
        
        // Check all visible required fields
        quizForm.find('input[required]:visible, select[required]:visible').each(function() {
            const $field = $(this);
            
            if ($field.is('input[type="radio"]')) {
                const name = $field.attr('name');
                if (!$(`input[name="${name}"]:checked`).length) {
                    isComplete = false;
                    return false;
                }
            } else if (!$field.val()) {
                isComplete = false;
                return false;
            }
        });

        return isComplete;
    }

    function getFormData() {
        const data = {};
        
        // Get all form values
        data.revenue = parseInt($('#revenue').val()) || 0;
        data.salons = Math.max(parseInt($('#salons').val()) || 1, 1); // Ensure minimum of 1
        data.ownBuilding = $('input[name="own_building"]:checked').val();
        data.buildings = parseInt($('#buildings').val()) || 0;
        data.shareholders = Math.max(parseInt($('#shareholders').val()) || 1, 1); // Ensure minimum of 1
        data.bookkeeping = $('input[name="bookkeeping"]:checked').val();
        data.bookkeepingBusinesses = parseInt($('#bookkeeping_businesses').val()) || 0;
        data.serviceLevel = $('input[name="service_level"]:checked').val();

        return data;
    }

    function performCalculation(data) {
        let total = 0;
        let details = [];

        // Question 1: Annual Revenue (base cost)
        total += data.revenue;
        details.push(`Base service fee: $${data.revenue.toLocaleString()}`);

        // Question 2: Number of Salons
        if (data.salons > 1) {
            const salonCost = (data.salons - 1) * 3000;
            total += salonCost;
            details.push(`Additional salons (${data.salons - 1} × $3,000): $${salonCost.toLocaleString()}`);
        }

        // Question 4: Number of Buildings (if applicable)
        if (data.ownBuilding === 'yes' && data.buildings > 0) {
            const buildingCost = data.buildings * 2000;
            total += buildingCost;
            details.push(`Buildings owned (${data.buildings} × $2,000): $${buildingCost.toLocaleString()}`);
        }

        // Question 5: Number of Shareholders
        if (data.shareholders > 1) {
            const shareholderCost = (data.shareholders - 1) * 1500;
            total += shareholderCost;
            details.push(`Additional shareholders (${data.shareholders - 1} × $1,500): $${shareholderCost.toLocaleString()}`);
        }

        // Question 7: Monthly Bookkeeping (if applicable)
        if (data.bookkeeping === 'yes' && data.bookkeepingBusinesses > 0) {
            const bookkeepingCost = data.bookkeepingBusinesses * 12000;
            total += bookkeepingCost;
            details.push(`Monthly bookkeeping (${data.bookkeepingBusinesses} × $12,000): $${bookkeepingCost.toLocaleString()}`);
        }

        // Question 8: Service Level Premium
        if (data.serviceLevel === 'premium') {
            let premiumCost = 0;
            if (data.revenue === 4000) premiumCost = 2000; // $0-$1M
            else if (data.revenue === 4500) premiumCost = 2500; // $1M-$5M
            else if (data.revenue === 5000) premiumCost = 3000; // $5M+
            
            total += premiumCost;
            details.push(`Premium service upgrade: $${premiumCost.toLocaleString()}`);
        } else if (data.serviceLevel === 'premium_plus') {
            let premiumPlusCost = 0;
            if (data.revenue === 4000) premiumPlusCost = 6500; // $0-$1M
            else if (data.revenue === 4500) premiumPlusCost = 7750; // $1M-$5M
            else if (data.revenue === 5000) premiumPlusCost = 9000; // $5M+
            
            total += premiumPlusCost;
            details.push(`Premium Plus service upgrade: $${premiumPlusCost.toLocaleString()}`);
        }

        return {
            total: total,
            details: details,
            serviceLevel: data.serviceLevel
        };
    }

    function displayResults(calculation) {
        let monthlyAmount, paymentPeriod, displayText;
        
        // Calculate monthly payment based on service level
        if (calculation.serviceLevel === 'basic') {
            monthlyAmount = Math.round(calculation.total / 6);
            paymentPeriod = '6 months';
        } else {
            // Premium and Premium Plus are paid over 12 months
            monthlyAmount = Math.round(calculation.total / 12);
            paymentPeriod = '12 months';
        }
        
        // Update price display with monthly amount and period
        displayText = `$${monthlyAmount.toLocaleString()} per month for ${paymentPeriod}`;
        priceDisplay.html(displayText);

        // Clear details display (no breakdown needed)
        detailsDisplay.html('');

        // Show results with animation
        if (!resultsDiv.is(':visible')) {
            resultsDiv.slideDown(400);
            
            // Scroll to results
            $('html, body').animate({
                scrollTop: resultsDiv.offset().top - 100
            }, 600);
        }
    }

    function updateHiddenFields() {
        const formData = getFormData();
        

        
        // Define mapping of quiz fields to hidden form fields
        const fieldMappings = {
            'input_8_8': {
                source: 'revenue',
                transform: function(value) {
                    switch(parseInt(value)) {
                        case 4000: return '$0-$1 Million';
                        case 4500: return '$1 Million-$5 Million';
                        case 5000: return '$5 Million+';
                        default: return '';
                    }
                }
            },
            // Add more field mappings here as needed:
            'input_8_9': {
                source: 'salons',
                transform: function(value) { return value.toString(); }
            },
            'input_8_10': {
                source: 'ownBuilding',
                transform: function(value) { 
                    return value ? value.toString() : ''; 
                }
            },
            'input_8_11': {
                source: 'buildings',
                transform: function(value) { return value.toString(); }
            },
            'input_8_12': {
                source: 'shareholders',
                transform: function(value) { return value.toString(); }
            },
            'input_8_13': {
                source: 'bookkeeping',
                transform: function(value) { 
                    return value ? value.toString() : ''; 
                }
            },
            'input_8_14': {
                source: 'bookkeepingBusinesses',
                transform: function(value) { return value.toString(); }
            },
            'input_8_15': {
                source: 'serviceLevel',
                transform: function(value) {
                    switch(value) {
                        case 'basic': return 'Basic';
                        case 'premium': return 'Premium';
                        case 'premium_plus': return 'Premium Plus';
                        default: return '';
                    }
                }
            }
        };

        // Update each mapped hidden field
        Object.keys(fieldMappings).forEach(fieldId => {
            const mapping = fieldMappings[fieldId];
            const hiddenField = $('#' + fieldId);
            

            
            if (hiddenField.length && formData[mapping.source] !== undefined) {
                const transformedValue = mapping.transform ? 
                    mapping.transform(formData[mapping.source]) : 
                    formData[mapping.source];
                
                hiddenField.val(transformedValue);
            }
        });
    }

    // Add some visual feedback for form completion
    function updateFormProgress() {
        const totalQuestions = quizForm.find('.quiz__question:visible').length;
        const completedQuestions = quizForm.find('.quiz__question:visible').filter(function() {
            const $question = $(this);
            const $inputs = $question.find('input, select');
            
            return $inputs.filter(function() {
                const $input = $(this);
                if ($input.is('input[type="radio"]')) {
                    return $(`input[name="${$input.attr('name')}"]:checked`).length > 0;
                }
                return $input.val() !== '';
            }).length > 0;
        }).length;

        // Add progress indicator if desired
        const progress = Math.round((completedQuestions / totalQuestions) * 100);
        
        // You can add a progress bar here if needed
        // console.log(`Progress: ${progress}%`);
    }

    // Note: updateFormProgress is now called from handleInputChange to avoid duplicate event handlers
});